import JSZip from 'jszip';
import { saveAs } from 'file-saver';

/**
 * Download a single audio file
 * @param {string} url - Audio file URL
 * @param {string} filename - Filename for download (e.g., "narration-1.mp3")
 */
export async function downloadAudioFile(url, filename) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch audio: ${response.statusText}`);
    const blob = await response.blob();
    saveAs(blob, filename);
  } catch (error) {
    console.error('Error downloading audio file:', error);
    throw error;
  }
}

/**
 * Download all audio files as a ZIP archive
 * @param {Array} items - Array of audio items with { title, url, id }
 * @param {string} bookTitle - Title of the book (for ZIP folder name)
 */
export async function downloadAllAudioAsZip(items, bookTitle = 'Narration') {
  if (!items || items.length === 0) {
    throw new Error('No audio files to download');
  }

  try {
    const zip = new JSZip();
    const audioFolder = zip.folder(bookTitle);

    // Fetch all audio files
    const fetchPromises = items.map(async (item, index) => {
      try {
        const response = await fetch(item.url);
        if (!response.ok) throw new Error(`Failed to fetch: ${item.title}`);
        const blob = await response.blob();
        
        // Create filename from title or index
        const title = item.title || `Track ${index + 1}`;
        const filename = `${String(index + 1).padStart(2, '0')}-${title.replace(/[^a-z0-9]/gi, '-').toLowerCase()}.mp3`;
        
        audioFolder.file(filename, blob);
      } catch (error) {
        console.error(`Error fetching audio for "${item.title}":`, error);
        // Continue with other files even if one fails
      }
    });

    await Promise.all(fetchPromises);

    // Generate ZIP and download
    const zipBlob = await audioFolder.generateAsync({ type: 'blob' });
    const timestamp = new Date().toISOString().split('T')[0];
    saveAs(zipBlob, `${bookTitle}-narration-${timestamp}.zip`);
  } catch (error) {
    console.error('Error creating ZIP archive:', error);
    throw error;
  }
}
